
<div class="border-top container-fluid p-0 d-lg-block">


    <footer class="footer-4 flex-column flex-lg-row flex-wrap gap-4 justify-content-center px-5 py-4 row">

        <div class="col-12  p-0" [ngClass]="hot_line != '' ?  '' :'col-lg-6' ">
            <div class="d-flex flex-column gap-2">
                <div>
                    <h1 class="font-mobile fs-5 fw-bold m-0 text-white">{{ "here_to_help" | translate: "footer" }}</h1>
                </div>
                <div class="d-flex gap-2">
                    <div>
                        <p class="m-0 text-white font-mobile">{{ "reach_out_to_us" | translate: "footer" }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 col-xl-5 d-flex flex-column flex-lg-row gap-3 gap-lg-5 justify-content-center p-0">

            <!-- item#1 -->
            <div class=" col align-items-center d-flex gap-3" *ngIf="help_center">
                <div class="d-flex gap-2 icon-box-style">
                    <div style="transform:scale(1);display:flex;align-items:center">
                        <div><img src="../../../assets/icon/info.svg" class="icom-w-style-2"></div>
                    </div>
                </div>
                <div>
                    <h1 class="fs-6 m-0 text-white custom-font-size-1">{{ "help_center" | translate: "footer" }}</h1>
                    <a href="tel: {{ help_center }}" class="font-mobile link-light text-decoration-none custom-font-size-2">
                        {{ help_center }}
                    </a>
                </div>
            </div>

            <!-- item#2 -->
            <div class="col align-items-center d-flex gap-3" *ngIf="email_support">
                <div class="d-flex gap-2 icon-box-style">
                    <div style="transform:scale(1);display:flex;align-items:center">
                        <div><img src="../../../assets/icon/email.svg" class="icom-w-style-2"></div>
                    </div>
                </div>
                <div>
                    <h1 class="fs-6 m-0 text-white custom-font-size-1"> {{ "email_support" | translate: "footer" }}</h1>
                    <a href="mailto: {{ email_support }}" class="font-mobile link-light text-decoration-none custom-font-size-2">
                        {{ email_support }}
                    </a>
                </div>
            </div>

            <!-- item#3 -->
            <div class="col align-items-center d-flex gap-3" *ngIf="hot_line">
                <div class="d-flex gap-2 icon-box-style">
                    <div style="transform:scale(1);display:flex;align-items:center">
                        <div><img src="../../../assets/icon/phone.svg" class="icom-w-style-2"></div>
                    </div>
                </div>
                <div>
                    <h1 class="fs-6 m-0 text-white  custom-font-size-2"> {{ "phone_support" | translate: "footer" }}</h1>
                    <a href="tel: {{ hot_line }}" class="font-mobile link-light text-decoration-none custom-font-size-2">
                        {{ hot_line }}
                    </a>
                </div>
            </div>

      </div>

  </footer>
</div>
